export default {
  title: "Performed Work",
  title_regular_work: "Performed Regular Work",
  title_performed_corrective_work: "Performed Corrective Work",
  title_right_container_corrective: "Events and Comments",
  title_right_container_regular: "Issues, Events and Comments",
  title_right_container_corrective_configure: "Configure Events and Comments",
  title_right_container_regular_configure: "Configure Issues, Events and Comments",
  title_corrective_work: "Corrective Work",
  table_column_designation_label: "Work Title",
  table_column_work_domain_label: "Work Domain",
  table_column_entity_grouping_label: "Entity Grouping",
  table_column_entity_grouping_item_class: "Item Class",
  table_column_entity_grouping_area_attribute_set: "Area Attribute Set",
  table_column_entity_label: "Entity",
  table_column_work_type_label: "Work type",
  table_column_work_type_regular_work: "Regular Work",
  table_column_work_type_corrective_work: "Corrective Work",
  table_column_work_order_label: "Work Order",
  table_column_date_performed_label: "Date Performed",
  tab_work_instructions: "Work Instructions",
  tab_item: "Item",
  tab_issue: "Issue",
  tab_issues: "Raised Issues",
  tab_issues_open_count: "Raised Issues ({count} Open)",
  tab_events: "Events",
  tab_comments: "Comments",
  work_statement_label: "Work Statement",
  corrective_work_statement_label: "Corrective Work Statement",
  performed_corrective_work: "Performed Corrective Work",
}
